
import newsComponent from "@/components/LandingPageNews.vue";
import { mapWaitingActions } from "vue-wait";

export default {
  head() {
    return {
      title: "Nyheter",
      titleTemplate: `%s |  ${this.$store.getters["cmsConfigHomepage/getChainName"]}`,
      meta: [
        {
          hid: "og:title",
          name: "og:title",
          content: `Nyheter |  ${this.$store.getters["cmsConfigHomepage/getChainName"]}`,
        },
        {
          hid: "og:description",
          name: "og:description",
          content:
            this.$store.getters["cmsConfigHomepage/getCmsConfigHomepage"]
              ?.homepageDescription,
        },
        {
          hid: "og:url",
          name: "og:url",
          content:
            this.$store.getters["cmsConfigHomepage/getCmsConfigHomepage"]
              ?.siteUrl,
        },
        {
          hid: "og:image",
          name: "og:image",
          content: this.$store.getters["cmsConfigHomepage/getLogo"],
        },
      ],
    };
  },
  layout: "HomepageLayout",
  components: { newsComponent },
  name: "news",
  data: () => ({
    isLandingPage: false,
  }),
  computed: {
    news() {
      return this.$store.getters["news/getNews"];
    },
  },
   methods: {
    ...mapWaitingActions("news", {
      fetchNewsBySiteIds: "loading initailize homepage fetchNewsBySiteIds",
    }),
   },
  async created(){
    if(!this.news.length){
      this.fetchNewsBySiteIds();
    }
  }
};
